 <template>
  <div>
    <div class="btn-wrapper d-flex justify-content-md-end justify-content-center">
      <button class="btn btn-primary wizard-btn next-btn mr-3" @click="$emit('input', 'CEE')">
        {{ $t("contract.request.new.request.CEE") }}
      </button>
      <button class="btn btn-primary wizard-btn next-btn" @click="$emit('input')" v-if="!this.$store.state.user.informations.permissions.some(permission => permission.groupReference == '_animateur')">
        {{ $t("contract.request.new.request") }}
      </button>
    </div>
    <div class="mt-3">
      <history-demands />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepOne',
  mounted() {
    localStorage.removeItem('model');
  },
  
  components: {
    HistoryDemands: () => import('../HistoryDemands.vue'),
  },
};
</script>

<style scoped></style>